import React, { useEffect, useState } from "react";
import Chart from "./charts/WeeklySales";
import PieChart from "./charts/PieChart";
import MonthlyChart from "./charts/MonthlyAnalysis";
import Typography from "@mui/material/Typography";
import ChartRange from "./charts/ChartRange";
import defaultImg from "../../images/defaultimg.png";
import {
  getOutStock,
  getProfitLoss,
  getRangeSales,
  getWeeklyPurchases,
  getWeeklySales,
  getYearlyPurchases,
  getYearlySales,
  getCashInHand,
  getBanksBalance,
  getPaymentData
} from "./httpCalls";
import TopCards from "./TopCards";
import { Box, Button, Grid, TextField } from "@mui/material";
import { Stack, styled } from "@mui/system";
import DialogComponent from "../reusableComponents/Dialog";
import OutOfStock from "./OutOfStock";
import { getQty } from "../../utils/getQty";
import { Provider, useDispatch, useSelector } from "react-redux";

const GraphBox = styled("div")({
  backgroundColor: "white",
  boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.3)",
  borderRadius: "25px",
  padding: "10px",
  margin: "10px",
  width: "100%",
  height: "380px",
});
const GridBox = styled("div")({
  marginTop: "20px",
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
  columnGap: "1%",
});
const DateRow = styled("div")({
  margin: "10px",
  paddingBottom: "10px",
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
  rowGap: "10%",
  columnGap: "1%",
});
const ItemBox = styled("div")({
  backgroundColor: "#ebebeb",
  padding: "10px",
  display: "grid",
  gridTemplateColumns: "20% 60% 20%",
  gap: 2,
  borderRadius: "20px",
  margin: "10px",
  boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.3)",
  cursor: "pointer",
});

function AdminDashboard() {
  let companyCode = localStorage.getItem("companyCode");
  const { loading,status } = useSelector((state) => state.trial);

  const [state, setState] = useState({
    open: false,
    totalItems: 0,
    totalSold: 0,
    totalSales:0,
    totalSale: 0,
    totalProfit: 0,
    totalLoss: 0,
    totalStock: 0,
    totalStockSale:0,
    cashInHand :0,
    totalPayments:0,
    totalBankBalance:0,
    startDate: "",
    endDate: "",
    outOfStock: [],
    next_page_token: "",
    sales: [],
    rangeSale: [],
    showRange: false,
    weekSales: {},
    weekPurchases: {},
    item: {},
    monthlySales: {},
    monthlyPurchases: {},
    yearlySales: {},
    yearlyPurchases: {},

  });

  useEffect(() => {
    getDashboardData();

    if (companyCode != 4416) {
      // weekSale();
      weekPurchase();
      getProfit();
      yearSale();
      yearPurchase();
      getCashInHandData();
      getBankData();
      getTotalPayment()
    }
  }, []);



  const yearSale = async () => {
    // let { months } = await getYearlySales();
    // setState((prev) => ({ ...prev, yearlySales: months }));
  };
  const yearPurchase = async () => {
    let { months } = await getYearlyPurchases();
    setState((prev) => ({ ...prev, yearlyPurchases: months }));
  };
  // const weekSale = async () => {
  //   const { weeklySales } = await getWeeklySales();
  //   setState((prev) => ({ ...prev, weekSales: weeklySales }));
  // };
  const weekPurchase = async () => {
    const { weekPurchases } = await getWeeklyPurchases();
    setState((prev) => ({ ...prev, weekPurchases: weekPurchases }));
  };

  const getProfit = async () => {
    const { totalLoss, totalProfit,totalSales } = await getProfitLoss(
    
      state.startDate,
      state.endDate
    );
    console.log('[rofit',totalProfit)
    setState((prev) => ({ ...prev, totalLoss, totalProfit ,totalSales}));
  };
  const getCashInHandData = async () => {
    const { cashInHand } = await getCashInHand(
    
      state.startDate,
      state.endDate
    );
    console.log('cash',cashInHand)
    setState((prev) => ({ ...prev, cashInHand }));
  };
 
  const getBankData = async () => {
    const { totalBankBalance } = await getBanksBalance(
    
      state.startDate,
      state.endDate
    );
    console.log('totalBankBalance',totalBankBalance)
    setState((prev) => ({ ...prev, totalBankBalance }));
  };

  const getTotalPayment = async () => {
    const { totalPayments } = await getPaymentData(
    
      state.startDate,
      state.endDate
    );
    console.log('totalPayments', totalPayments)
    setState((prev) => ({ ...prev, totalPayments }));
  };

  const getDashboardData = async () => {
    function formatDate(date) {
      const day = String(date.getDate()).padStart(2, '0'); // Get day and pad with 0 if necessary
      const month = String(date.getMonth() + 1).padStart(2, '0'); // Get month (0-indexed, so +1) and pad
      const year = date.getFullYear(); // Get full year
  
      return `${day}-${month}-${year}`;
  }
  
  // Get current date
  const currentDate = new Date();
  
  // Format the current date as dd-mm-yyyy
  const formattedDate = formatDate(currentDate);

    const token = state.next_page_token;
    let data = await getOutStock(token, formattedDate, formattedDate);
    console.log('ddddd',data)
    setState((prev) => ({
      ...prev,
      next_page_token: data.next_page_token,
      totalItems: data.totalItems,
      totalStock: data.totalStock,
      totalSold: data.soldItems,
      totalSale: data.totalSales,
      totalStockSale:data.totalStockSalePrice,
      outOfStock: [...state.outOfStock, ...data.outOfStock],
    }));
  };

  const filterbyDate = async () => {
    const { saleRange } = await getRangeSales(state.startDate, state.endDate);
    console.log("saleRange",saleRange)
    setState((prev) => ({ ...prev, rangeSale: saleRange }));
  };

  const toggleChart = () => {
   
    if (state.startDate && state.endDate) {
      setState((prev) => ({ ...prev, showRange: !prev.showRange }));
      filterbyDate();
       getDashboardData() 
      getProfit(state.startDate,state.endDate);
      getCashInHandData(state.startDate,state.endDate);
      getBankData(state.startDate,state.endDate);
      getTotalPayment(state.startDate,state.endDate)
    } else {
      setState((prev) => ({ ...prev, showRange: false, rangeSale: "" }));
    }
  };

  const handleInput = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    setState((prev) => ({ ...prev, [name]: value }));
  };
  const toggleItem = (item = "") => {
    setState((prev) => ({ ...prev, item: item, open: !prev.open }));
  };

  return (
    <Box sx={{ mt: { md: 1, xs: "40px" } }}>
      <TopCards
        totalItems={state.totalItems}
        totalSold={state.totalSold}
        totalPrice={state.totalStock}
        totalSaleStock={state.totalStockSale}
        totalSale={state.totalSale}
        totalSales={state.totalSales}
        totalProfit={state.totalProfit}
        totalCashInHand={state.cashInHand}
        totalBankBalance={state.totalBankBalance}
        totalPayments={state.totalPayments}
      />
      {companyCode != 4416 && (
        <>
          <DateRow>
            {!state.showRange && (
              <Stack
                direction="row"
                width="100%"
                spacing={2}
                alignItems="center"
              >
                <label>From</label>
                <TextField
                  variant="outlined"
                  size="small"
                  type="date"
                  name="startDate"
                  value={state.startDate}
                  onChange={handleInput}
                  sx={{ width: { md: "100%", xs: "70%" }, bgcolor: "#fff" }}
                />
              </Stack>
            )}
            {!state.showRange && (
              <Stack
                direction="row"
                width="100%"
                alignItems="center"
                spacing={4}
              >
                <label>To</label>
                <TextField
                  style={{ background: "white" }}
                  variant="outlined"
                  size="small"
                  type="date"
                  name="endDate"
                  value={state.endDate}
                  onChange={handleInput}
                  sx={{ width: { md: "100%", xs: "70%" } }}
                />
              </Stack>
            )}
            <Button
              variant="contained"
              sx={{
                width: { md: "100%", xs: "80%" },
                backgroundColor: "#4EAF51",
                color: "white",
                mb: "10px",
              }}
              onClick={toggleChart}
            >
              {state.showRange ? "Show Daily Sales" : "Show Graph"}
            </Button>
          </DateRow>

          {/* <GraphBox
            sx={{
              mt: { md: "5px", xs: "20px", m: "0px" },
              ml: { md: "0px", xs: "-3px" },
            }}
          >
            <Typography
              sx={{
                mt: 1,
                fontWeight: "bold",
                color: "#757575",
                fontSize: { md: "1.8rem", xs: "1.2rem" },
              }}
            >
              {state.showRange ? `Sales Range` : "Weekly Sales"}
            </Typography>
            {state.showRange && <ChartRange rangeSale={state.rangeSale} />}
            {!state.showRange && (
              <Chart sales={state.weekSales} type="Sale" totalColor="#757575" />
            )}
          </GraphBox> */}

          <GraphBox sx={{ ml: { md: "0px", xs: "-3px" } }}>
            <Typography
              sx={{
                mt: 1,
                fontWeight: "bold",
                color: "#4CAF50",
                fontSize: { md: "1.8rem", xs: "1.2rem" },
              }}
            >
              Weekly Purchases
            </Typography>
            <Chart
              sales={state.weekPurchases}
              type="Purchase"
              totalColor="#4CAF50"
            />
          </GraphBox>
          {/* <GraphBox sx={{ ml: { md: "0px", xs: "-3px" } }}>
            <Typography
              sx={{
                mt: 3,
                fontWeight: "bold",
                color: "#757575",
                fontSize: { md: "1.8rem", xs: "1.2rem" },
              }}
            >
              Monthly Analysis
            </Typography>
            <MonthlyChart
              sales={state.yearlySales}
              type="Sale"
              totalColor="#757575"
            />
          </GraphBox> */}
          <GraphBox sx={{ ml: { md: "0px", xs: "-3px" } }}>
            <Typography
              sx={{
                mt: 3,
                fontWeight: "bold",
                color: "#4CAF50",
                fontSize: { md: "1.8rem", xs: "1.2rem" },
              }}
            >
              Monthly Purchases Analysis
            </Typography>
            <MonthlyChart
              sales={state.yearlyPurchases}
              type="Purchase"
              totalColor="#4CAF50"
            />
          </GraphBox>
          <GridBox>
            <GraphBox
              sx={{
                ml: { md: "0px", xs: "-3px" },
                height: { md: "460px", xs: "400px" },
              }}
            >
              <Typography
                sx={{
                  mt: 1,
                  fontWeight: "bold",
                  color: "#757575",
                  fontSize: { md: "1.5rem", xs: "1rem" },
                }}
              >
                Out Of Stock Items
              </Typography>
              <Box
                sx={{
                  overflow: "auto",
                  overflowX: "hidden",
                  height: { md: "380px", xs: "300px" },
                }}
              >
                {state?.outOfStock?.map((item, index) => {
                  return (
                    <ItemBox key={index} onClick={() => toggleItem(item)}>
                      <img src={defaultImg} height="50px" width="50px" />
                      <Typography
                        variant="subtitle2"
                        sx={{ display: "flex", alignItems: "center" }}
                      >
                        {item.name}
                      </Typography>
                      <Typography
                        variant="subtitle2"
                        sx={{ display: "flex", alignItems: "center" }}
                      >
                        {getQty(item)?.qty}
                      </Typography>
                    </ItemBox>
                  );
                })}
                {state?.outOfStock?.length > 0 &&
                  state.next_page_token != "" && (
                    <Button variant="outlined" onClick={getDashboardData}>
                      Load More
                    </Button>
                  )}
              </Box>
            </GraphBox>
            <GraphBox
              sx={{
                ml: { md: "0px", xs: "-3px" },
                height: { md: "460px", xs: "400px" },
              }}
            >
              <Typography
                sx={{
                  mt: 3,
                  fontWeight: "bold",
                  color: "#757575",
                  fontSize: { md: "1.5rem", xs: "1rem" },
                }}
              >
                Profit and Loss
              </Typography>
              <PieChart
                sale={state.totalSales}
                rangeSale={state.rangeSale}
                profit={state.totalProfit}
                loss={state.totalLoss}
              />
            </GraphBox>
          </GridBox>
        </>
      )}
      <DialogComponent
        title="Out Of Stock"
        open={state.open}
        onClose={toggleItem}
        onClickCancel={toggleItem}
        dialogContent={<OutOfStock item={state.item} />}
      />
    </Box>
  );
}

export default AdminDashboard;
